<div class="banner">
  <div class="button-container flex align-baseline">
    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'design'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Ontwerp')"
        (click)="changeSelectedView('design')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'design'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ designCount }}"
          [matBadgeHidden]="designCount == null || designCount === 0"
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Ontwerp
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'print'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Print')"
        (click)="changeSelectedView('print')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'print'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ printCount }}"
          [matBadgeHidden]="printCount == null || printCount === 0"
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Print
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'finishing'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Afwerking')"
        (click)="changeSelectedView('finishing')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'finishing'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ finishCount }}"
          [matBadgeHidden]="finishCount == null || finishCount === 0"
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Afwerking
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'suppliers'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Ext. leveranciers')"
        (click)="changeSelectedView('suppliers')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'suppliers'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ supplierCount }}"
          [matBadgeHidden]="supplierCount == null || supplierCount === 0"
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Ext. leveranciers
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'verify_location'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Locatiebepaling')"
        (click)="changeSelectedView('verify_location')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'verify_location'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ verifyLocationCount }}"
          [matBadgeHidden]="
            verifyLocationCount == null || verifyLocationCount === 0
          "
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Locatiebepaling
      </button>
    </div>

    <div class="flex">
      <button
        [ngClass]="
          selectedOverview === 'to_execute'
            ? 'selected-button border-badge-selected'
            : 'non-selected-button border-badge'
        "
        [ngStyle]="getSelectButtonWidth('Te plaatsen')"
        (click)="changeSelectedView('to_execute')"
        type="button"
        mat-button
      >
        <span
          class="span-badge-margin"
          [ngClass]="
            selectedOverview === 'to_execute'
              ? 'border-badge-selected'
              : 'border-badge'
          "
          matBadge="{{ placeCount }}"
          [matBadgeHidden]="placeCount == null || placeCount === 0"
          [matBadgeSize]="'medium'"
          matBadgeOverlap="false"
        ></span>
        Te plaatsen
      </button>
    </div>
  </div>
</div>

<design-projects
  *ngIf="selectedOverview === 'design'"
  (reloadCountChange)="refreshCounts()"
>
</design-projects>

<print-projects
  *ngIf="selectedOverview === 'print'"
  (reloadCountChange)="refreshCounts()"
>
</print-projects>

<finishing-projects
  *ngIf="selectedOverview === 'finishing'"
  (reloadCountChange)="refreshCounts()"
>
</finishing-projects>

<supplier-projects
  *ngIf="selectedOverview === 'suppliers'"
  (reloadCountChange)="refreshCounts()"
>
</supplier-projects>

<verify-location-projects
  *ngIf="selectedOverview === 'verify_location'"
  (reloadCountChange)="refreshCounts()"
></verify-location-projects>

<place-projects
  *ngIf="selectedOverview === 'to_execute'"
  (reloadCountChange)="refreshCounts()"
>
</place-projects>

<pending-projects *ngIf="selectedOverview === 'pending'"></pending-projects>
